import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AngularFireStorage } from '@angular/fire/storage';
import { finalize } from 'rxjs/operators';
import { BrdsqlService } from 'src/app/core/services/brdsql.service';
import { yearCrCPC } from 'src/environments/global-constants';
import { Subscription, UnsubscriptionError } from 'rxjs';
import { formatDate } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FileUploadCanequalityService } from 'src/app/services/file-upload-canequality.service';
import { FileUpload } from 'src/app/model/file-upload.model';
import { EncryptUrlService } from 'src/app/services/encrypt-url.service';

@Component({
  selector: 'app-save-form-canequality',
  templateUrl: './save-form-canequality.component.html',
  styleUrls: ['./save-form-canequality.component.css']
})
export class SaveFormCanequalityComponent {

  saveForm: FormGroup;
  imagePreview: string | ArrayBuffer | null = null;
  isUploading: boolean = false;
  yearCr: string | null = null;
  private subscription: Subscription;
  imageUrl? = '';
  categories: string[] = ['ยอดยาว', 'กาบใบ', 'ดินทราย', 'ราก', 'อื่นๆ'];
  selectedCategories: string[] = [];
  // last used
  selectedFile: File | null = null;
  uploadProgress: number = 0;
  downloadURL: string | null = null;
  encryptedURL: string | null = null; // 🔐 เก็บค่าหลังจากเข้ารหัส

  constructor(
    private fb: FormBuilder,
    private storage: AngularFireStorage,
    private brdsql: BrdsqlService,
    private uploadService: FileUploadCanequalityService,
    private encryptService: EncryptUrlService,
    public dialogRef: MatDialogRef<SaveFormCanequalityComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any // รับค่าที่ส่งมาจาก Parent
  ) {

    console.log('data dialog: ', data[0]);
    let dataIn: any = data[0];

    this.saveForm = this.fb.group({
      production_year_id: ['9', Validators.required], // fixed year
      truck_q: [dataIn.truck_q, Validators.required],
      user_id: ['0', Validators.required],
      contaminants: ['', Validators.required],
      details: [''],
      image: [null, Validators.required],
      imageUrl: ['', Validators.required],
      doc_status: ['0', Validators.required],
    });

  }

  ngOninit() {
    // this.getYearId();
  }

  ngAfterContentInit(): void {
    // this.getYearId();
  }

  getYearId() {
    const yearCPC = yearCrCPC();
    let yearData: any = [];
    this.subscription = this.brdsql.productionyear()
      .subscribe({
        next(res) {
          // console.log('productionyear res: ' ,res)
          if (res.code !== "EREQUEST") {
            yearData = res.recordset;  //
            yearData = yearData.filter(el => el.code == yearCPC)
            yearData = yearData[0]
            console.log('yearData.filter : ', yearData)
            console.log('yearData.id : ', yearData.id)
            // this.saveForm.patchValue(yearData);
            this.form.setValue({
              production_year_id: yearData.id
            });
          } else {
            yearData = []
          }
        }, error(err) {
          console.log('err:', err)
        }, complete: () => {
        },
      })
  }

  onCancel(): void {
    this.dialogRef.close(); // ปิด Dialog โดยไม่ส่งค่ากลับ
  }

  // ฟังก์ชันเลือกไฟล์
  onFileSelected(event: any) {
    this.selectedFile = event.target.files[0] || null;
    if (this.selectedFile) {
      this.saveForm.patchValue({ image: this.selectedFile });
      const reader = new FileReader();
      reader.onload = () => this.imagePreview = reader.result as string;
      reader.readAsDataURL(this.selectedFile);
    }
  }

  // ฟังก์ชันอัพโหลดไฟล์
  uploadFile() {
    if (!this.selectedFile) return;

    const fileExtension = this.selectedFile.name.split('.').pop(); // ดึงนามสกุลไฟล์ (jpg, png, etc.)
    const truck_q = this.saveForm.get('truck_q')?.value + '.' + fileExtension;
    // const filePath = `canequality/${Date.now()}_${this.selectedFile.name}`;
    const filePath = `canequality/${truck_q}`;
    const fileRef = this.storage.ref(filePath);
    const task = this.storage.upload(filePath, this.selectedFile);

    // อัพเดต % ความคืบหน้า
    task.percentageChanges().subscribe(progress => {
      if (progress !== undefined) this.uploadProgress = progress;
    });

    // เมื่ออัพโหลดเสร็จแล้ว ดึง URL ของไฟล์
    task.snapshotChanges().pipe(
      finalize(() => {
        fileRef.getDownloadURL().subscribe(url => {
          this.downloadURL = url;
          this.encryptedURL = this.encryptService.encryptURL(url); // 🔐 เข้ารหัส URL
          console.log("Encrypted URL :", this.encryptedURL);
          this.saveForm.patchValue({ imageUrl: this.encryptedURL });
        });
      })
    ).subscribe();
  }

  saveToDB() {
    const f: any = this.saveForm.value;
    // console.log('save form to db: ', f)
    this.brdsql.saveCaneQuality(f)
      .subscribe({
        next(res: any) {
          // console.log('res save to db : ', res);
          if (res.code == "EREQUEST") {
            alert("!!เกิดความผิดพลาดในการบันทึกข้อมูล ให้ลองอีกครั้ง")
          } else {
            alert("(^-^) บันทึกข้อมูลแล้ว")
          }
        },
        error: (err) => {
          console.log('!!save Error')
        },
        complete: () => {
          console.log('(^-^) complete dialogRef close with data: ', this.data);
          this.dialogRef.close(this.data); // ปิด Dialog และส่งค่ากลับ Parent
        },
      })
  }

  ngOnDestroy(): void {
    // this.subscription.unsubscribe();
  }



}
